// @flow
import * as React from 'react';
import { injectIntl } from 'react-intl';

// Components
import AppointmentFlowHeader from 'components/molecules/AppointmentFlowHeader/';
import SignIn from 'components/pages/User/SignIn/SignInContainer';
import AppointmentInfo from 'components/molecules/AppointmentInfo/';

// Constants
import { HOME_ROUTE } from 'constants/routes';

// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';
const ns = 'signinpage';

type Props = {
  intl: IntlShape
};

const SignInPage = ({ intl }: Props) => {
  return (
    <div className={ns}>
      <header>
        <AppointmentInfo key="appointmentInfo" />
        <AppointmentFlowHeader
          label={intl.formatMessage({ id: 'c8.header.home' })}
          routeTo={HOME_ROUTE}
          backButtonAriaLabel={intl.formatMessage({
            id: 'c8.aria.back.to.start.page',
            defaultMessage: 'Back to Start Page'
          })}
        />
      </header>
      <SignIn />
    </div>
  );
};

export default injectIntl(SignInPage);



// WEBPACK FOOTER //
// ./src/components/pages/User/SignIn/index.js